import { FILTER_KEYS, type FilterKey } from '@meridian/contracts';

import styles from './universe-filter.module.css';

import type { JSX } from 'react';

export interface UniverseFilterProps {
  readonly value: FilterKey;
  readonly onChange: (value: FilterKey) => void;
}

export function UniverseFilter({ value, onChange }: UniverseFilterProps): JSX.Element {
  return (
    <div className={styles['group']} role="group" aria-label="Universe filter">
      {FILTER_KEYS.map((key) => (
        <button
          key={key}
          type="button"
          className={styles['btn']}
          aria-pressed={value === key}
          onClick={() => {
            onChange(key);
          }}
        >
          {key}
        </button>
      ))}
    </div>
  );
}
